// extracted by mini-css-extract-plugin
export default {"container":"Tooltip_container__Me9q2","tooltip":"Tooltip_tooltip__2LGJO","visible":"Tooltip_visible__F57GA","text":"Tooltip_text__ykGYm"};